import React from "react";

import NovEyeLogsList from "../features/videos/NovEyeLogsList";
import RobotNavigation from "../features/robot/RobotNavigation";

function NovEyeLogsPage() {
  return (
    <>
      <RobotNavigation />
      <NovEyeLogsList />
    </>
  );
}

export default NovEyeLogsPage;
